import { ColumnData } from './../base-models/column-data';
import { UserService } from './user.service';
import { BaseEntity } from './../base-models/base-entity';
import { Injectable } from '@angular/core';
import { TreeviewItem, TreeItem } from 'ngx-treeview';
import { List } from 'immutable';

@Injectable({
  providedIn: 'root'
})
export class CollectionService {

  constructor(protected userService: UserService) { }

  FilterItems<T extends BaseEntity>(items, filterBy: string | null, columnName: string = '', tableColumns: ColumnData[] = []) {
    if(filterBy){
      filterBy = filterBy.toLocaleLowerCase();
      return items.filter((item: T) => {
        return Object.keys(item).some(prop => {
          if(this.filterByColumn(prop, tableColumns) && (prop == columnName || columnName == '')){
            let value = item[prop];
            if(!value) return false;
            if(typeof value === 'string'){
              value = value.toLocaleLowerCase();
            }
            return value.toString().indexOf(filterBy) !== -1;
          }
          else
            return false;
        })
      })
    }
    else
      return items;
  }

  private filterByColumn(columnName: string, tableColumns: ColumnData[]): boolean{
    if(tableColumns.length == 0)
      return true;

      let filterByColumn: boolean = false;

      tableColumns.forEach(column => {
      if(columnName == column.Name)
        filterByColumn = true;
    })

    return filterByColumn;
  }

  SortItems<T extends BaseEntity>(items: List<T>, sortBy: string, reverse: boolean): List<T> {
    if(items)
      return items.sort((val1, val2) => {
        //let value1 = (typeof val1[sortBy] === 'string') ? val1[sortBy].toLocaleLowerCase() : val1[sortBy];
        //let value2 = (typeof val2[sortBy] === 'string') ? val2[sortBy].toLocaleLowerCase() : val2[sortBy];
        let value1 = this.getSortItemPropertyValue(val1[sortBy]);
        let value2 = this.getSortItemPropertyValue(val2[sortBy]);
        if(value1 && value2 && this.isString(value1))
          return !reverse ? value1.localeCompare(value2, this.userService.GetLocaleString()) : value2.localeCompare(value1, this.userService.GetLocaleString());
        if(value1 < value2) return !reverse ? -1 : 1;
        if(value1 > value2) return !reverse ? 1 : -1;
        return 0;
      })
  }

  private isString(value){
    return (typeof value === 'string');
  }

  private isNumber(value){
    return (typeof value === 'number');
  }

  private isBoolean(value){
    return (typeof value === 'boolean');
  }

  GetPagination(totalItems: number, currentPage: number = 1, pageSize: number = 10){
    let totalPages = Math.ceil(totalItems / pageSize);

    if(currentPage < 1)
      currentPage = 1;
    else if(currentPage > totalPages)
      currentPage = totalPages;

    let startPage: number;
    let endPage: number;

    if(totalPages <= 10){
      startPage = 1;
      endPage = totalPages;
    }
    else{
      if(currentPage <= 6){
        startPage = 1;
        endPage = 10;
      }
      else if(currentPage + 4 >= totalPages){
        startPage = totalPages - 9;
        endPage = totalPages;
      }
      else{
        startPage = currentPage - 5;
        endPage = currentPage + 4;
      }
    }

    let startIndex = (currentPage + 1) * pageSize;
    let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

    let pages = Array.from(Array((endPage + 1) - startPage).keys()).map(i => startPage + i);

    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startPage: startPage,
      endPage: endPage,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages
    }
  }

  GetPropertiesValues(item: any, property: string){//console.log('Collection service: GetPropertiesValues');
    if(property.indexOf(',') == 1)
      return item[property];
    else{
      let value: string = '';
      property.split(',').forEach(property => {
        value += this.getPropertyValue(item, property) + ' - ';
      })
      return value.substring(0, value.length - 3);
    }
  }

  private getPropertyValue(item: any, property: string){//console.log('Collection service: GetPropertyValue');
    if(property.indexOf('.')== -1)
      return item != null ? item[property] : '';
    else{
      let firstProperty = property.substring(0, property.indexOf('.'));
      let restProperty = property.substring(property.indexOf('.') + 1);
      return this.getPropertyValue(item[firstProperty], restProperty);
    }
  }

  public ConvertToTreeviewItems<T extends BaseEntity>(items: T[], propertyName: string, tableColumns: ColumnData[]){
    let treeviewItems: TreeviewItem[] = [];

    items.forEach((item: T) => {
      //let treeItem: TreeItem = {text: item[propertyName], value: item.ID, checked: true, disabled: false, collapsed: false, children: null };
      let treeItem: TreeItem = {text: this.createTreeviewItemText(item, tableColumns, propertyName), value: item.ID, checked: true, disabled: false, collapsed: false, children: null };
      if(item['Items'])
        treeItem.children = this.ConvertToTreeviewItems(item['Items'], propertyName, tableColumns);
      let treeviewItem: TreeviewItem = new TreeviewItem(treeItem);
      treeviewItems.push(treeviewItem);
    })
    return treeviewItems;
    
  }

  private createTreeviewItemText(item, tableColumns: ColumnData[], propertyName: string){
    let text: string = '';
    if(tableColumns != null && tableColumns.length > 0){
      tableColumns.forEach(column => {
        text += item[column.Name] + '        -        ';
      })
      text = text.substring(0, text.length - 17);
      return text;
    }
    else{
      return item[propertyName];
    }
  }

  private convertItemsToTreeview(items, propertyName){
  }

  private getSortItemPropertyValue(property: any){
    if(property == null)
      return null;
    switch(typeof(property)){
      case 'object': {
        if(property instanceof Date)
          return property;
        if(property['day']) return new Date(property['year'], property['month'] - 1, property['day']);
          return property[0];
      }
      case 'number': {
        return property;
      }
      case 'string': {
        return property.toLocaleLowerCase();
      }
      default: return null;
    }
  }
}
